module.exports = __webpack_public_path__ + "static/img/wealth_level_66.bc813cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_66.png
// module id = lvET
// module chunks = 0